export default __webpack_public_path__ + "static/media/logo_x2.c1dcf1f3.png";